import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 95D3325D-257A-433C-8B2E-D674C21BA268
 * name volume-source
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-source.svg
 * tags
 * - Cellphone / Phone 
 * - Audio 
 */
export const VolumeSourceIcon = createSvgIcon(<><path d="M3 9V15H7L12 20V4L7 9H3M16 15H14V9H16V15M20 19H18V5H20V19Z" /></>, 'VolumeSourceIcon');
export default VolumeSourceIcon